<template>
  <footer class="l-footer">
    <footer-page-top></footer-page-top>

    <footer-navigation></footer-navigation>

    <footer-sp-navigation></footer-sp-navigation>

    <footer-bottom></footer-bottom>
  </footer>
</template>

<script>
import FooterPageTop from "@/components/molecules/FooterPageTop";
import FooterNavigation from "@/components/molecules/FooterNavigation";
import FooterSpNavigation from "@/components/molecules/FooterSpNavigation";
import FooterBottom from "@/components/molecules/FooterBottom";

export default {
  components: {
    FooterPageTop,
    FooterNavigation,
    FooterSpNavigation,
    FooterBottom,
  },
};
</script>
